import React, { useState } from "react";

import { logEvent } from "@internal/analytics";
import { IconButton } from "@shared/buttons";

import { NewSalesExperienceSwitch } from "../new-sales-experience-switch";
import { useSalesViews } from "../sales-views-context";

import { ManageSalesViewModal } from "./manage-sales-view-modal/manage-sales-view-modal";
import { MaxViewsModal } from "./max-views-modal";
import { SaveNewSalesViewModal } from "./save-new-sales-view-modal";
import { SavedViewsSelect } from "./saved-views-select";

export const MAX_SAVED_VIEWS = 25 as const;

export const SavedViews = () => {
  const { hasSalesViewChanges, salesViews } = useSalesViews();

  const [isSaveSalesViewsOpen, setIsSaveSalesViewsOpen] = useState(false);
  const [isManageSalesViewsOpen, setIsManageSalesViewsOpen] = useState(false);
  const [isMaxViewsModalOpen, setIsMaxViewsModalOpen] = useState(false);

  const openSaveNewSalesViewModal = () => {
    logEvent("Saved Views: User clicked on Save new sales view button");
    if (salesViews.length < MAX_SAVED_VIEWS) {
      setIsSaveSalesViewsOpen(true);
    } else {
      logEvent("Saved Views: User reached max saved views");
      setIsMaxViewsModalOpen(true);
    }
  };

  const openManageSalesViewsModal = () => {
    logEvent("Saved Views: User clicked on Manage sales views button");
    setIsManageSalesViewsOpen(true);
  };

  return (
    <>
      <div
        data-testid="saved-views"
        className="flex justify-between p-4 pb-0 bg-white"
      >
        <div className="flex items-center">
          <SavedViewsSelect />
          <IconButton
            className="ml-2"
            // HACK to override the padding on the IconButton
            ref={(node) =>
              node?.style.setProperty("padding", "0.5rem", "important")
            }
            variant="tertiary"
            onClick={openSaveNewSalesViewModal}
            rightIcon={
              <i className="fa-regular fa-sharp fa-plus-circle text-[13px]" />
            }
            isDisabled={!hasSalesViewChanges}
            tooltip={
              !hasSalesViewChanges
                ? "Make adjustments to the page to save a new view"
                : "Save all filters and page selections as a new view"
            }
          >
            SAVE
          </IconButton>
          <IconButton
            ref={(node) =>
              node?.style.setProperty("padding", "0.5rem", "important")
            }
            variant="tertiary"
            onClick={openManageSalesViewsModal}
            rightIcon={
              <i className="fa-regular fa-sharp fa-gear text-primary" />
            }
          >
            MANAGE
          </IconButton>
        </div>
        <NewSalesExperienceSwitch />
      </div>
      <SaveNewSalesViewModal
        isOpen={isSaveSalesViewsOpen}
        close={() => setIsSaveSalesViewsOpen(false)}
      />
      <ManageSalesViewModal
        isOpen={isManageSalesViewsOpen}
        close={() => setIsManageSalesViewsOpen(false)}
      />
      <MaxViewsModal
        isOpen={isMaxViewsModalOpen}
        close={() => setIsMaxViewsModalOpen(false)}
      />
    </>
  );
};
